import { createAction, props } from '@ngrx/store';
import { TravelCounsellorsList } from 'src/app/shared/models/TravelCounsellorsList';

export const setTravelCounsellors = createAction(
  '[Travel Counsellors] Set Travel Counsellors',
  props<{ list: TravelCounsellorsList }>(),
);

export const clearTravelCounsellorsState = createAction('[Travel Counsellors] Clear State');
